import { AlumniServicePath } from "utils/constants";

export const alumniRequests = {
  rejectAlumniProfile: id => `${AlumniServicePath}alumni/${id}/reject`,
  approveAlumniProfile: id => `${AlumniServicePath}alumni/${id}/activate`,
  returnForCorrectionAlumniProfile: id => `${AlumniServicePath}alumni/${id}/corrections`,
};
